import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

/**
 * All nodes reported to the consumer must take this shape
 */
export var TraceNode = /*#__PURE__*/_createClass(function TraceNode(name, start, end, origin, type) {
  _classCallCheck(this, TraceNode);

  this.n = name;
  this.s = start;
  this.e = end;
  this.o = origin;
  this.t = type;
});